import { render, staticRenderFns } from "./configChat.vue?vue&type=template&id=df56ae56&scoped=true"
import script from "./configChat.vue?vue&type=script&lang=js"
export * from "./configChat.vue?vue&type=script&lang=js"
import style0 from "./configChat.vue?vue&type=style&index=0&id=df56ae56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df56ae56",
  null
  
)

export default component.exports